<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">聲明</v-stepper-step>
        <v-divider/>
        <v-stepper-step :editable="step > 1" :complete="step > 2" step="2">方式</v-stepper-step>
        <v-divider/>
        <v-stepper-step :complete="step > 3" step="3">匯入</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <p>清大學程小幫手為學生開發，我們力求資料的正確性，但實際規定仍以課務組為主。</p>
          <p>
            <span>我們<span class="green--text">僅</span>取得您的修課紀錄，包含：</span>
            <ul>
              <li>科號</li>
              <li>成績</li>
            </ul>
          </p>
          <p>
            <span>我們<span class="red--text">沒有</span>取得您的個人資料，如：</span>
            <ul>
              <li>姓名</li>
              <li>學號</li>
              <li>系級</li>
            </ul>
          </p>
          <v-container text-xs-right class="pa-0">
            <v-btn color="primary" @click="step = 2">我同意</v-btn>
            <v-btn flat @click="cancel">取消</v-btn>
          </v-container>
          
        </v-stepper-content>
      </v-stepper-items>
      <v-stepper-items>
        <v-stepper-content class="pa-0" step="2">
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm6 @click="autoImport" style="cursor: pointer;">
                <v-card>
                  <v-card-title><h3>自動匯入</h3></v-card-title>
                  <v-card-media :src="require('../assets/import-auto.gif')" height="200px"/>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 @click="manualImport" style="cursor: pointer;">
                <v-card>
                  <v-card-title><h3>手動複製</h3></v-card-title>
                  <v-card-media :src="require('../assets/import-manual.gif')" height="200px"/>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="3">
          <h4 v-if="importType === IMPORT_TYPE_AUTO">請貼上登入<a target="_blank" href="https://www.ccxp.nthu.edu.tw/ccxp/INQUIRE/">校務資訊系統</a>後的連結</h4>
          <h4 v-else>進入成績查詢頁面，從黃色底開始複製，複製到粉色底「修習總學分」</h4>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
            <v-textarea
              v-if="importType === IMPORT_TYPE_MANUAL"
              label="修課紀錄"
              :rules="textRules"
              v-model="text"/>
            <v-text-field
              v-else
              label="連結"
              :rules="urlRules"
              v-model="url"
              placeholder="https://www.ccxp.nthu.edu.tw/ccxp/INQUIRE/select_entry.php?ACIXSTORE=6991bcrjqktcjampue1nrugeu0"/>
            <img :src="imgSrc" style="width: 100%"/>
            <v-btn
              color="primary"
              :loading="loading"
              @click="submit"
              :disabled="!valid">匯入</v-btn>
            <v-btn flat @click="cancel">取消</v-btn>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import { SET_IMPORT_DIALOG, FETCH_COURSE_LOG, SET_COURSE_LOG, LOG_COURSE_LOG } from '../store/constants';
import { parseCourseLog } from '../functions/parseCourseLog';

const IMPORT_TYPE_AUTO = 'IMPORT_TYPE_AUTO';
const IMPORT_TYPE_MANUAL = 'IMPORT_TYPE_MANUAL';

export default {
  name: 'import-dialog',
  data() {
    return {
      step: 1,
      importType: null,
      IMPORT_TYPE_AUTO,
      IMPORT_TYPE_MANUAL,
      url: '',
      text: '',
      tempCourseLog: [],
      valid: true,
      urlRules: [
        v => !!v || '必填',
        v => /(https:\/\/)?www.ccxp.nthu.edu.tw\/ccxp\/INQUIRE\/select_entry.php\?ACIXSTORE=[a-z0-9]{26}/.test(v) || '請貼上正確的連結',
      ],
      textRules: [
        v => !!v || '必填',
        v => this.validateText(v) || '請貼上正確的修課紀錄',
      ],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['importDialog']),
    dialog: {
      get() { return this.importDialog; },
      set(value) { this[SET_IMPORT_DIALOG](value); }
    },
    imgSrc() {
      return this.importType === IMPORT_TYPE_AUTO ? require('../assets/import-auto.gif') : require('../assets/import-manual.gif');
    },
  },
  watch: {
    importDialog(value) {
      if (value) return;
      this.step = 1;
      this.importType = null;
      this.$refs.form.reset();
      this.tempCourseLog = [];
      this.loading = false;
    },
  },
  methods: {
    ...mapActions([SET_IMPORT_DIALOG, FETCH_COURSE_LOG, SET_COURSE_LOG, LOG_COURSE_LOG]),
    autoImport() {
      this.step++;
      this.importType = IMPORT_TYPE_AUTO;
    },
    manualImport() {
      this.step++;
      this.importType = IMPORT_TYPE_MANUAL;
    },
    validateText(v) {
      this.tempCourseLog = parseCourseLog(v);
      return this.tempCourseLog.length > 0;
    },
    cancel() {
      this[SET_IMPORT_DIALOG](false);
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.importType === IMPORT_TYPE_AUTO) {
          this[FETCH_COURSE_LOG](/[a-z0-9]{26}/.exec(this.url)[0]);  
        } else {
          this[LOG_COURSE_LOG](this.tempCourseLog);
        }
        this.cancel();
        this.$vuetify.goTo('#course-log');
      }
    },
  },
}
</script>
